import React, { Fragment } from "react";
import { StyleSheet, View, Text } from "@react-pdf/renderer";

const PDFTable = ({ data, heading, Width }) => {
  if (!data || (data && data.length == 0)) {
    return;
  }
  let width;
  if (Width) {
    width = Width;
  } else {
    width = (100 / data.length).toString() + "%";
  }

  var styles = StyleSheet.create({
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderColor: "#bfbfbf",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      color: "#333333",
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
    },
    tableColHeader: {
      width: width,
      borderStyle: "solid",
      borderColor: "#bfbfbf",
      borderBottomColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCol: {
      width: width,
      borderStyle: "solid",
      borderColor: "#bfbfbf",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    tableCellHeader: {
      margin: "auto",
      fontSize: 10,
      fontWeight: 500,
    },
    tableCell: {
      margin: "auto",
      fontSize: 8,
    },
    one: {
      backgroundColor: "#fff",
    },
    two: {
      backgroundColor: "#ececec",
    },
  });

  return (
    <Fragment>
      <View style={styles.table}>
        <View
          style={{
            margin: "auto",
            flexDirection: "row",
            backgroundColor: "#d4d7de",
          }}
        >
          {heading.map((e, i) => {
            return (
              <View style={styles.tableColHeader} key={i}>
                <Text style={styles.tableCellHeader}>{e.title}</Text>
              </View>
            );
          })}
        </View>
        <View>
          {data.map((e, i) => {
            return (
              <View
                style={[styles.tableRow, i % 2 === 0 ? styles.one : styles.two]}
                key={i}
              >
                {e.map((d, l) => (
                  <View style={styles.tableCol} key={l}>
                    <Text style={styles.tableCell}>{d}</Text>
                  </View>
                ))}
              </View>
            );
          })}
        </View>
      </View>
    </Fragment>
  );
};
export default PDFTable;



// WEBPACK FOOTER //
// ./src/components/parts/pdfmaker/common/pdfTable.jsx